<template>
  <div class="about-us-modular">
    <div class="about-us-header-modular">
      <img class="header-bg-img" src="../assets/aboutUs/header-bg.png" alt="" />
      <div class="about-us-header-title">
        <div>
          <!-- {{ $t("translateText.aboutusText") }} -->
          {{ pageTextArr[0] }}
        </div>
      </div>
    </div>
    <div class="about-us-body-modular">
      <!-- <div style="margin: 20px auto; width: 1200px">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">{{
            currLanguageId == 3 ? "Home" : pageTextArr[1]
          }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{
            currLanguageId == 3 ? "About us" : pageTextArr[0]
          }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div> -->
      <!-- <div class="header-menu-bar-modular" style="background-color: transparent;">
         <div class="menu-bar">
          <div class="menu-bar-item">
            <span class="top-bar-title" @click="toPersonCenter()">{{ currLanguageId == 3 ? "Home" : pageTextArr[1]
            }}</span>
            <img class="top-bar-icon" src="../assets/productDetail/top-bar-icon.png"
              alt="">
          </div>
          <div class="menu-bar-item">
            <span class="top-bar-title">{{ currLanguageId == 3 ? "Home" : pageTextArr[0] }}</span>

          </div>
        </div> 
      </div> -->
      <div class="about-us-body-item about-us-body-item1">
        <div class="about-us-body-item-modualr">
          <div class="about-us-body-item-header-title">
            {{ aboutUsInfo.item1.title }}
          </div>
          <div class="about-us-body-item-header-introduce">
            {{ aboutUsInfo.item1.introduce }}
          </div>
          <div class="about-us-body-item-line"></div>
          <div class="about-us-body-item-trait">
            {{ aboutUsInfo.item1.trait }}
          </div>
          <div class="about-us-body-item-img">
            <div class="body-item-img">
              <img class="introduce-img" :src="aboutUsInfo.item1.img" alt="" />
            </div>
            <div class="about-us-body-item-bordr">
              <div class="red-boder"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="about-us-body-item about-us-body-item2">
        <div class="about-us-body-item-header-title">
          {{ aboutUsInfo.item2.title }}
        </div>
        <div class="about-us-body-item-header-characteristic">
          {{ aboutUsInfo.item2.trait }}
        </div>
        <div class="about-us-body-item-header-down-icon">
          <img class="down-arrow-icon" src="../assets/aboutUs/title-down-arrow-icon.png" alt="" />
        </div>
        <div class="about-us-body-modular">
          <el-row :gutter="60">
            <el-col :span="8" :xs="24" v-for="(item, index) in aboutUsInfo.item2.introduceList" :key="index">
              <div class="info-item-modular">
                <div class="info-item-img">
                  <img class="introduce-tar-img" :src="item.image" alt="" />
                </div>
                <div class="info-item-title">{{ item.title }}</div>
                <div class="info-item-line"></div>
                <div class="info-item-content">{{ item.desc }}</div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="about-us-body-item about-us-body-item3">
        <div class="about-us-body-item-header">
          <div class="about-us-body-item-header-title">
            {{ aboutUsInfo.item3.title }}
          </div>
          <div class="about-us-body-item-header-characteristic">
            {{ aboutUsInfo.item3.trait }}
          </div>
          <div class="about-us-body-item-header-down-icon">
            <img class="down-arrow-icon" src="../assets/aboutUs/title-down-arrow-icon.png" alt="" />
          </div>
        </div>
        <div class="about-us-body-item-content-modualr">
          <el-row :gutter="10">
            <el-col :span="12" :xs="24">
              <div class="map-modular">
                <MapModular ref="mapContainerRef"></MapModular>
              </div>
            </el-col>
            <el-col :span="12" :xs="24">
              <div class="detail-info-modular">
                <div class="contact-us-item-modular">
                  <div class="contact-us-title">
                    <!-- {{ pageText.title1Text }} -->
                    {{ pageTextArr[2] }}

                  </div>
                  <div class="contact-us-item">
                    <div class="item-icon">
                      <img class="address-icon" src="../assets/aboutUs/address-icon.png" alt="" />
                    </div>
                    <span class="contact-us-item-msg" style="display: inline-block">
                      <!-- {{pageText.addressText}} -->
                      {{ pageTextArr[4] }}
                      ：{{ pageText.sys_addressText }}</span>
                  </div>
                  <div class="contact-us-item">
                    <div class="item-icon">
                      <img class="zipCode-icon" src="../assets/aboutUs/zipCode-icon.png" alt="" />
                    </div>
                    <span class="contact-us-item-msg">
                      <!-- {{pageText.zipCodeText}} -->
                      {{ pageTextArr[5] }}
                      ：{{ pageText.sys_zipText }}</span>
                  </div>
                  <div class="contact-us-item">
                    <div class="item-icon">
                      <img class="user-icon" src="../assets/aboutUs/user-icon.png" alt="" />
                    </div>
                    <span class="contact-us-item-msg">
                      <!-- {{pageText.addresseeText}} -->
                      {{ pageTextArr[6] }}
                      ：{{ pageText.sys_contactText }}</span>
                  </div>
                </div>
                <div class="customer-service-modular">
                  <div class="customer-service-title">
                    <!-- {{pageText.title2Text }} -->
                    {{ pageTextArr[3] }}
                  </div>
                  <div class="customer-service-item">
                    <div class="item-icon">
                      <img class="mobile-icon" src="../assets/aboutUs/mobile-icon.png" alt="" />
                    </div>
                    <span class="customer-service-item-msg">
                      <!-- {{ pageText.mobileText }} -->
                      {{ pageTextArr[7] }}
                      ：{{ pageText.sys_phoneText }}</span>
                  </div>
                  <div class="customer-service-item">
                    <div class="item-icon">
                      <img class="qq-icon" src="../assets/aboutUs/qq-icon.png" alt="" />
                    </div>
                    <span class="customer-service-item-msg">{{ pageText.qqText }}：{{ pageText.sys_qqText }}</span>
                  </div>
                  <div class="customer-service-item">
                    <div class="item-icon">
                      <img class="email-icon" src="../assets/aboutUs/email-icon.png" alt="" />
                    </div>
                    <span class="customer-service-item-msg">
                      <!-- {{ pageText.emailText }} -->
                      {{ pageTextArr[8] }}
                      ：{{ pageText.sys_mailText }}</span>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MapModular from "../components/public/map";

export default {
  components: {
    MapModular,
  },
  data() {
    return {
      currLanguageId: 0,
      aboutUsInfo: {
        item1: {
          title: "我们是SMT制造商",
          introduce:
            "主要设备:锡膏印刷机; SMT贴片机; 台式回流焊机;通道式回流焊机;智能红外返修台; 预热台;激光切割和雕刻机。",
          trait: "SMT一站式",
          img: "",
        },
        item2: {
          title: "我们是SMT制造商",
          trait: "让客户省心、安心、放心",
          introduceList: [
            {
              img: require("../assets/aboutUs/introduce-tar-img-1.png"),
              title: "地理位置",
              content:
                "公司总部位置位于中国山东省泰安市，坐落于泰山脚下，环境优美，地理位置优越。",
            },
            {
              img: require("../assets/aboutUs/introduce-tar-img-2.png"),
              title: "生产环境",
              content:
                "独立生产车间，生产设备先进，生产技术发达，生产销售一体化。",
            },
            {
              img: require("../assets/aboutUs/introduce-tar-img-3.png"),
              title: "主营产品",
              content:
                "锡膏印刷机、自动贴片机、回流焊机、智能红外返修设备、预热设备等。",
            },
          ],
        },
        item3: {
          title: "联系我们",
          trait:
            "我们很乐意收到您的来信-请将您的信息或想法发送给我们。或者干脆进来喝杯新鲜的茶和一块饼干",
          detailInfo: {
            title1: "",
            address: "公司地址：",
            zipCode: "邮     编：",
            addressee: "收件人：Jack先生",
            title2: "客户服务",
            mobile: "电      话：18865488807",
            qq: "Q       Q：1339270445",
            email: "电子邮件：ginkgoem@hotmail.com",
            eng_address: "",
            eng_addressee: "",
          },
        },
      },
      aboutUsData: [],
      pageText: {
        homeText: "首页",
        aboutusText: "关于我们",
        title1Text: "联系我们",
        addressText: "公司地址",
        zipCodeText: "邮编",
        addresseeText: "收件人",
        title2Text: "客户服务",
        mobileText: "电话",
        qqText: "QQ",
        emailText: "电子邮件",
        sys_addressText: "",
        sys_zipText: "",
        sys_contactText: "",
        sys_phoneText: "",
        sys_qqText: "",
        sys_mailText: "",
      },
      pageTextArr: [
        '关于我们',
        '首页',
        '联系我们',
        '客户服务',
        '公司地址',
        '邮编',
        '收件人',
        '电话',
        '电子邮件'
      ],
    };
  },
  methods: {
    /**
     * 关于我们
     */
    aboutUs() {
      let that = this;
      this.$http.aboutUs(
        null,
        (res) => {
          if (res.ret == 1) {
            that.aboutUsInfo.item1.title = res.data.first_title;
            that.aboutUsInfo.item1.introduce = res.data.first_desc;
            that.aboutUsInfo.item1.trait = res.data.first_img_desc;
            that.aboutUsInfo.item1.img = res.data.first_img;

            that.aboutUsInfo.item2.title = res.data.second_title;
            that.aboutUsInfo.item2.trait = res.data.second_desc;
            // that.aboutUsInfo.item2.introduceList = JSON.parse(res.data.second_img);
            that.aboutUsInfo.item2.introduceList = res.data.pic_info;

            that.aboutUsInfo.item3.title = res.data.third_title;
            that.aboutUsInfo.item3.trait = res.data.third_desc;

            // // 地址
            // that.aboutUsInfo.item3.detailInfo.address = res.data.sys_address;
            // // 邮编
            // that.aboutUsInfo.item3.detailInfo.zipCode = res.data.sys_zip;
            // // 收件人
            // that.aboutUsInfo.item3.detailInfo.addressee = res.data.sys_contact;
            // // 电话
            // that.aboutUsInfo.item3.detailInfo.mobile = res.data.sys_phone;
            // // QQ
            // that.aboutUsInfo.item3.detailInfo.qq =
            //   "Q       Q：" + res.data.sys_qq;
            // // 点赞邮件
            // that.aboutUsInfo.item3.detailInfo.email = res.data.sys_mail;

            that.aboutUsInfo.item3.detailInfo.eng_address =
              res.data.eng_sys_address;
            that.aboutUsInfo.item3.detailInfo.eng_addressee =
              res.data.eng_sys_contact;

            that.pageText.sys_addressText = res.data.sys_address;
            that.pageText.sys_zipText = res.data.sys_zip;
            that.pageText.sys_contactText = res.data.sys_contact;
            that.pageText.sys_phoneText = res.data.sys_phone;
            that.pageText.sys_qqText = res.data.sys_qq;
            that.pageText.sys_mailText = res.data.sys_mail;
            // that.pageTranslate(); 
            // api数据翻译
            let aboutUsData = [
              res.data.first_title,
              res.data.first_desc,
              res.data.first_img_desc,
              res.data.second_title,
              res.data.second_desc,
              res.data.third_title,
              res.data.third_desc,
              res.data.sys_address,
              res.data.sys_contact,
              res.data.pic_info[0].title,
              res.data.pic_info[0].desc,
              res.data.pic_info[1].title,
              res.data.pic_info[1].desc,
              res.data.pic_info[2].title,
              res.data.pic_info[2].desc,
            ];
            that.languageTranslateByArr(aboutUsData);
          } else {
            this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },
    /**
   * 语言翻译 - 单个
   * @param {*} text
   * @param {*} callback
   * @param {*} errCallBack
   */
    translate(text, callback, errCallBack) {
      let that = this;
      let data = {
        text: text, //带翻译文本
        from: localStorage.getItem("oldLanguageCode"), //源语言
        to: localStorage.getItem("curLanguageCode"), //目标语言
      };
      if (data.from == data.to) {
        return;
      }
      this.$http.translate(data, callback, errCallBack);
    },

    /**
     * 语言翻译
     * @param {*} text
     */
    languageTranslate(text) {
      let that = this;
      let newText = "";
      this.translate(
        text,
        (res) => {
          that.processingResults(res.data);
          // that.pageText[param] = newText;
        },
        (res) => {
          newText = "";
        }
      );
    },

    /**
     * 处理翻译返回的结果
     * @param {*} param
     */
    pageTranslate(param) {
      let that = this;
      let transformText = "";
      for (const key in that.pageText) {
        transformText += key + ":" + that.pageText[key] + "&";
      }

      that.languageTranslate(transformText);
    },

    /**
     * 处理返回的结果
     */
    processingResults(data) {
      let that = this;
      let textArr = data.split("&amp;");

      textArr.forEach((v, i) => {
        if (v != "") {
          for (const key in that.pageText) {
            if (v.split(":")[0] == key) {
              that.pageText[key] = v.split(":")[1];
            }
          }
        }
      });
    },

    /**
     * 语言翻译 - 数组
     * @param {*} arr
     */
    languageTranslateByArr(arr) {
      let that = this;
      this.$parent.translateByArr(
        arr,
        (res) => {
          // 翻译api类型
          that.processingResultsByArr(res.data);
        },
        (res) => { }
      );
    },
    /**
     * api 处理返回的翻译数据
     * @param {*} data
     */
    processingResultsByArr(data) {
      let that = this;
      that.aboutUsInfo.item1.title = data[0].translation;
      that.aboutUsInfo.item1.introduce = data[1].translation;
      that.aboutUsInfo.item1.trait = data[2].translation;

      that.aboutUsInfo.item2.title = data[3].translation;
      that.aboutUsInfo.item2.trait = data[4].translation;
      // that.aboutUsInfo.item2.introduceList = JSON.parse(res.data.second_img);

      that.aboutUsInfo.item3.title = data[5].translation;
      that.aboutUsInfo.item3.trait = data[6].translation;
      that.pageText.sys_addressText =
        data[7].translation;
      that.pageText.sys_contactText =
        data[8].translation;

      that.aboutUsInfo.item2.introduceList[0].title = data[9].translation;
      that.aboutUsInfo.item2.introduceList[0].desc = data[10].translation;
      that.aboutUsInfo.item2.introduceList[1].title = data[11].translation;
      that.aboutUsInfo.item2.introduceList[1].desc = data[12].translation;
      that.aboutUsInfo.item2.introduceList[2].title = data[13].translation;
      that.aboutUsInfo.item2.introduceList[2].desc = data[14].translation;
    },
    translateByArr(arr, callback, errCallBack) {
      let that = this;
      let data = {
        text: arr, //带翻译数组
        from: localStorage.getItem("oldLanguageCode"), //源语言
        to: localStorage.getItem("curLanguageCode"), //目标语言
      };
      if (data.from == data.to) {
        return;
      }
      this.$http.translateByArr(data, callback, errCallBack);
    },

    languageTranslateByArrs(arr) {
      let that = this
      let newpagetextArr = []
      that.translateByArr(arr, res => {
        console.log("res", res);
        res.data.forEach((item, index) => {
          newpagetextArr.push(item.translation)
        })
        that.pageTextArr = newpagetextArr
      })
    },

    /**
     * 跳转个人中心
     */
    toPersonCenter() {
      this.$router.push(
        {
          path: '/',
        }
      )
    },
  },
  mounted() {
    let that = this;
    that.aboutUs();
    that.currLanguageId = localStorage.getItem("curLanguageType");
    that.languageTranslateByArrs(that.pageTextArr)

  },
};
</script>


// WEBPACK FOOTER //
// src/view/aboutUs.vue